import React from "react";
import { Box, Chip, Grid, Typography } from "@mui/material";
import { ExtractedAuditData } from "../utils/excel-parser";

interface ExtractedMetadataSummaryProps {
  extractedData: ExtractedAuditData;
}

export const ExtractedMetadataSummary: React.FC<ExtractedMetadataSummaryProps> = ({
  extractedData,
}) => {
  return (
    <Box
      sx={{
        mt: 3,
        p: 2.5,
        backgroundColor: "#f0f7ff",
        borderRadius: 2,
        border: "1px solid #b3d8ff",
      }}
    >
      <Typography variant="subtitle2" fontWeight="700" color="primary.main" gutterBottom>
        Extracted Audit Metadata
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="caption" color="text.secondary" display="block">
            Selected CB Name
          </Typography>
          <Typography variant="body2" fontWeight="600">
            {extractedData.selectedCbName}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="caption" color="text.secondary" display="block">
            Mapped CB Code
          </Typography>
          <Chip label={extractedData.cbCode} size="small" color="primary" sx={{ fontWeight: 700 }} />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="caption" color="text.secondary" display="block">
            Certified Org TE-ID
          </Typography>
          <Typography variant="body2" fontWeight="600">
            {extractedData.teId}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="caption" color="text.secondary" display="block">
            Audit Start Date
          </Typography>
          <Typography variant="body2" fontWeight="600">
            {extractedData.auditStartDate}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="caption" color="text.secondary" display="block">
            Audit End Date
          </Typography>
          <Typography variant="body2" fontWeight="600">
            {extractedData.auditEndDate}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};
